<mat-card mat-dialog-content class="sdp-delete-account">
	<h3 class="sdp-delete-account-header">{{ "account.delete.title" | translate }}</h3>
	<form [formGroup]="deleteForm" (ngSubmit)="submit()" novalidate>
		<div class="sdp-form-control">
			<div class="sdp-delete-account-confirmation-text">
				{{ accountDeleteConfirmation }}
			</div>
			<mat-form-field class="sdp-form-control-input-container">
				<input matInput placeholder="{{ 'account.delete.placeholder' | translate }}" type="text" formControlName="confirmation">
				<mat-error *ngIf="deleteForm.controls['confirmation'].hasError('constant') && isFormSubmitted">{{ "error.account.delete" | translate }}.</mat-error>
			</mat-form-field>
		</div>
		<div class="sdp-form-buttons-container sdp-delete-account-buttons-container">
			<button [disabled]="inProgress" class="sdp-button-small-text" type="button" color="primary" mat-button (click)="cancel()">{{ "sdp.label.cancel" | translate }}</button>
			<button [disabled]="inProgress" type="submit" color="primary" mat-raised-button>{{ "sdp.label.delete" | translate }}</button>
		</div>
		<mat-card *ngIf="errorMessage" class="sdp-error-card">{{ errorMessage }}</mat-card>
	</form>
	<mat-progress-bar mode="indeterminate" *ngIf="inProgress" class="sdp-progress-bar-bottom"></mat-progress-bar>
</mat-card>